import React from "react";
import type { EquipmentCategoryType } from "../../../utils/types";
import { useEquipmentV2Selector } from "../../../redux/store";
import { EquipmentV2Label } from "../../../utils/labels";
import * as EquipmentStyles from "../styles/Equipments";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import { IconRainbowCircle } from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import EquipmentContent from "./EquipmentContent";
import { trackCustomizeLink } from "../../../utils/tracking";
import { getBuildUrl } from "../../../utils/utils";
import GlobalStyle from "../../../../../../common-deprecated/styles/v2/common/GlobalStyle";
import { getThemeClassname } from "../../../../../../common-deprecated/utils";

type SharedEquipmentProps = {
    equipmentLabels: (string | null)[];
    equipment: EquipmentCategoryType[];
};

const Equipment = (props: SharedEquipmentProps): JSX.Element => {
    const { equipmentLabels, equipment } = props;
    const commonSettings = useEquipmentV2Selector((state) => state.commonSettings);
    const selectedCar = useEquipmentV2Selector((state) => state.equipment.selectedCar);

    return (
        <EquipmentStyles.Wrapper className={getThemeClassname(selectedCar.modelId)}>
            <GlobalStyle />
            <Flex.Row>
                <Flex.Col width={{ xs: 1, lg: 1 / 4 }}>
                    <EquipmentStyles.Title>{equipmentLabels[0]}</EquipmentStyles.Title>
                    <EquipmentStyles.CustomizeButton
                        onClick={() => trackCustomizeLink(commonSettings.component)}
                        href={getBuildUrl(selectedCar, commonSettings)}
                        rel="nofollow"
                    >
                        <IconRainbowCircle />
                        <EquipmentV2Label label="equipmentCustomize" />
                    </EquipmentStyles.CustomizeButton>
                </Flex.Col>
                <Flex.Col width={{ xs: 1, lg: 3 / 4 }} mt={{ xs: 2, lg: 0 }}>
                    <EquipmentStyles.ContentWrapper>
                        {equipmentLabels[1] && (
                            <EquipmentStyles.Description>{equipmentLabels[1]}</EquipmentStyles.Description>
                        )}
                        <EquipmentContent content={equipment} />
                    </EquipmentStyles.ContentWrapper>
                </Flex.Col>
            </Flex.Row>
        </EquipmentStyles.Wrapper>
    );
};

export default Equipment;
